// Types needed by shared entities
export type TImageLocation = {
  signedUrl: string;
  urlExpiration: number; // Timestamp in milliseconds when the URL expires
  fileName: string;
};
